import { render, staticRenderFns } from "./studentQuestionListInfo.vue?vue&type=template&id=1e729cb4&scoped=true"
import script from "./studentQuestionListInfo.vue?vue&type=script&lang=js"
export * from "./studentQuestionListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e729cb4",
  null
  
)

export default component.exports